"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirebaseCollection = void 0;
var FirebaseCollection;
(function (FirebaseCollection) {
    // System
    FirebaseCollection["Notifications"] = "Notifications";
    FirebaseCollection["EventLogger"] = "EventLogger";
    // Core
    FirebaseCollection["Users"] = "Users";
    FirebaseCollection["Squadrons"] = "Squadrons";
    FirebaseCollection["Events"] = "Events";
    FirebaseCollection["EventIDs"] = "EventIDs";
    FirebaseCollection["AircrewTypes"] = "AircrewTypes";
    FirebaseCollection["UsersEvents"] = "UsersEvents";
    FirebaseCollection["Url"] = "Url";
    FirebaseCollection["Mds"] = "Mds";
    FirebaseCollection["UsersSupportRequests"] = "UsersSupportRequests";
    FirebaseCollection["UserAvailability"] = "UserAvailability";
    FirebaseCollection["EventComments"] = "EventComments";
    FirebaseCollection["SarmCodes"] = "SarmCodes";
    FirebaseCollection["Rating"] = "Rating";
    FirebaseCollection["FailedPushNotifications"] = "FailedPushNotifications";
    // Its - SARM
    FirebaseCollection["Its"] = "Its";
    FirebaseCollection["ItsSquadronTemplates"] = "ItsSquadronTemplates";
    FirebaseCollection["ItsTasksGroups"] = "ItsTasksGroups";
    FirebaseCollection["AccomplishmentReports"] = "AccomplishmentReports";
    FirebaseCollection["StanEval"] = "StanEval";
    FirebaseCollection["Dnif"] = "Dnif";
    // Official forms
    FirebaseCollection["Afto781"] = "Afto781";
    FirebaseCollection["Af1522"] = "Af1522";
    FirebaseCollection["Af3956"] = "Af3956";
    FirebaseCollection["PayStatus"] = "PayStatus";
    FirebaseCollection["Afto781Metrea"] = "Afto781Metrea";
    FirebaseCollection["Afto782Metrea"] = "Afto782Metrea";
    FirebaseCollection["InFlightIssueLogMetrea"] = "InFlightIssueLogMetrea";
    FirebaseCollection["Aircraft"] = "Aircraft";
    FirebaseCollection["AircraftProfile"] = "AircraftProfile";
    FirebaseCollection["AircraftDetail"] = "AircraftDetail";
    // Training Dashboard
    FirebaseCollection["LetterX"] = "LetterX";
    FirebaseCollection["CertificationEvent"] = "CertificationEvent";
    FirebaseCollection["Dd791"] = "Dd791";
    FirebaseCollection["GradeRank"] = "GradeRank";
    // Current Ops Dashboard
    FirebaseCollection["StereoPlanRoutes"] = "StereoPlanRoutes";
    // Mission Documents
    FirebaseCollection["MissionDocuments"] = "MissionDocuments";
})(FirebaseCollection = exports.FirebaseCollection || (exports.FirebaseCollection = {}));
